const fieldValidation = {
  required: '{{fieldName}} is required',
  maxLength: 'up tp {{value}} characters only',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
